import { render, staticRenderFns } from "./formFAQ.vue?vue&type=template&id=9ef9b48e&"
import script from "./formFAQ.vue?vue&type=script&lang=js&"
export * from "./formFAQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports